module.exports = __webpack_public_path__ + "img/income.b64baf7b.png";